import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className="fixed bottom-[5.5rem] right-6 z-50 w-14 h-14 rounded-full bg-muted/80 backdrop-blur border border-border/50 flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-transform duration-200 text-muted-foreground hover:text-foreground"
    >
      <ArrowUp className="w-5 h-5" aria-hidden="true" focusable="false" />
    </button>
  );
}
